import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LiveResultsService} from "@services";
import {LANDING_ROUTE} from "../app-routing.module";
import {EventItem, FetchEventByIdRequest} from "@model";

export const LiveEventResolver: ResolveFn<Observable<EventItem | null> |
  Promise<EventItem> | EventItem> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService),
   router: Router = inject(Router)): Observable<EventItem | null> |
    Promise<EventItem> | EventItem => {
    let eventId = route.queryParams["eventId"];
    if (eventId) {
      return liveResultsService.fetchLiveEvent(
        new FetchEventByIdRequest(eventId), true)
        .pipe(take(1),
          mergeMap((res: EventItem | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    } else {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    }
  }
